import { type BlockerFunction } from "react-router-dom"

import usePrompt from "./use-prompt.ts"

const useConfirm = (when: boolean | BlockerFunction) => {
  const blocker = usePrompt(when)

  const resetConfirmation = () => {
    if (blocker.state === "blocked") blocker.reset()
  }

  const onConfirm = () => {
    if (blocker.state === "blocked") setTimeout(blocker.proceed, 0)
  }

  return {
    isActive: blocker.state === "blocked",
    onConfirm,
    resetConfirmation
  }
}

export default useConfirm
